import { createContext, useContext, useState, useCallback } from 'react';

const PlaygroundContext = createContext();

export const usePlayground = () => useContext(PlaygroundContext);

export const PlaygroundProvider = ({ children }) => {
    const [isPlaygroundMode, setIsPlaygroundMode] = useState(
        () => sessionStorage.getItem('playgroundMode') === 'true'
    );

    const enterPlayground = useCallback(() => {
        sessionStorage.setItem('playgroundMode', 'true');
        setIsPlaygroundMode(true);
    }, []);

    const exitPlayground = useCallback(() => {
        Object.keys(sessionStorage)
            .filter(key => key.startsWith('pg_') || key === 'playgroundMode')
            .forEach(key => sessionStorage.removeItem(key));
        sessionStorage.removeItem('authUser');
        setIsPlaygroundMode(false);
    }, []);

    return (
        <PlaygroundContext.Provider value={{ isPlaygroundMode, enterPlayground, exitPlayground }}>
            {children}
        </PlaygroundContext.Provider>
    );
};
